import { OrganizationPageLayout } from './OrganizationPageLayout';
export default OrganizationPageLayout;
